import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { useLocation, useParams } from 'react-router-dom';
import Observer from 'react-intersection-observer';
import SliderCustomer from './Slider';
import Loader from '../../components/Loader/Loader';
import ViewHeader from '../../components/Header/ViewHeader';
import GrandBoothProductList from './GrandBoothProductList';
import { BOOTH_TYPE } from '../../common/Constants';

export const Header = (props) => {
    const { eventInfo, companyInfo } = props;
    return (
        <>
            {!_.isEmpty(eventInfo) && (
                <ViewHeader
                    eventName={eventInfo.name}
                    title={companyInfo.full_name || ''}
                    isIntl={false}
                    eventInfo={eventInfo}
                />
            )}
        </>
    );
};

Header.defaultProps = {
    eventInfo: {},
    companyInfo: {},
};

Header.propTypes = {
    eventInfo: PropTypes.oneOfType([() => null, PropTypes.object]),
    companyInfo: PropTypes.oneOfType([() => null, PropTypes.object]),
};

const ProductListOnDisplay = (props) => {
    const {
        getInformationEvent,
        getProductListOnDisplay,
        getFavoriteCompany,
        getCommonCompanyInfo,
        getCompanyIdsByEvent,
        productList,
        getProduct,
        sendBusinessCard,
        clearGetInformationEvent,
        clearExchangeBusinessCard,
        productListOnDisplay,
        isLoading,
        token,
        isAuthorized,
        product,
        companyInfo,
        eventInfo,
        successSendBusinessCard,
        companyIds,
        companies,
        favoriteCompanyIds,
        isWeakAuth,
        infoAddToCart,
        addProductToCart,
        clearAddToCart,
        getCount,
        customText,
        customColorExhibitor,
        customTextPersonInfo,
        getCustomText,
        clearCustomText,
        customTextCompany,

          /*  ★★ */
        customTimerctrl,
        getSettingCustomTimerctrl,
        clearCustomTimerctrl,
                
        locale,
    } = props;
    const routeParams = useParams();
    const localLang = sessionStorage.getItem('valueLang') || 'ja';
    const { shortName, companyId } = routeParams;
    const [eventDisplayBusinessCard, setEventDisplayBusinessCard] = useState(null);
    const [companyList, setCompanyList] = useState([]);
    const queryString = new URLSearchParams(useLocation().search);
    const queryObject = {
        company_name: queryString.get('company_name'),
        product_name: queryString.get('product_name'),
        company_type: queryString.get('company_type'),
        organizer_booth: queryString.get('organizer_booth'),
        zone_id: queryString.get('zone_id'),
    };
    const explore_all = queryString.get('explore_all');
    const is_favorite = queryString.get('is_favorite');
    const is_preview = queryString.get('is_preview');

    const queryParams = Object.keys(queryObject).filter((key) => queryObject[key]).reduce((prev, current) => ({
        ...prev,
        [current]: queryObject[current],
    }), {});

    function parseQueryString() {
        let queryStr = '';
        if (is_favorite) {
            return `?is_favorite=${is_favorite}`;
        }

        const params = Object.keys(queryParams).map((key) => `${key}=${queryParams[key]}`).join('&');
        if (params && explore_all) {
            queryStr = `?${params}&explore_all=${explore_all}`;
        } else if (params) {
            queryStr = `?${params}`;
        } else {
            queryStr = `?explore_all=${explore_all}`;
        }

        return queryStr;
    }

    const queryStr = parseQueryString();

    useEffect(() => {
        if (localLang === locale || is_preview) {
            getCustomText({
                eventShortName: shortName,
                site: 0,
                text_type: 2,
                language: locale,
            });
            getCommonCompanyInfo({ companyId, language: localLang });
        }

        getCompanyIdsByEvent({
            shortName,
            queryParams,
            locale,
        });

        return () => {
            clearGetInformationEvent();
            clearCustomText();
        };
    }, [companyId, shortName, clearGetInformationEvent, getCommonCompanyInfo, getCompanyIdsByEvent, locale]);

    useEffect(() => {
        if (!_.isEmpty(companyInfo) && (localLang === locale || is_preview)) {
            getProductListOnDisplay({
                event_name: shortName,
                company_id: companyId,
                page: 1,
                page_size: parseInt(companyInfo.organizer_booth, 10) === BOOTH_TYPE.GRAND ? 24 : 5,
                language: locale,
            });
        }
    }, [companyInfo, locale]);

    useEffect(() => {
        if (!_.isEmpty(eventInfo) && isWeakAuth === '' && isAuthorized && !is_preview) {
            getFavoriteCompany(locale);
        }
    }, [eventInfo, getFavoriteCompany]);

    useEffect(() => {
        if (is_favorite) {
            if (!_.isEmpty(favoriteCompanyIds)) {
                setCompanyList(favoriteCompanyIds);
            }
        } else {
            // eslint-disable-next-line no-lonely-if
            if (explore_all === 'false') {
                setCompanyList(companyIds);
            } else {
                setCompanyList(companies.results.map((item) => item.id));
            }
        }
    }, [companyIds, companies.results, explore_all, favoriteCompanyIds]);

    useEffect(() => {
        if (_.isEmpty(eventInfo) || _.isEmpty(companyInfo)) return;

        if (companyInfo.organizer_booth === '0') return;

        const booth = {
            1: 'small_zone',
            2: 'standard_zone',
            3: 'big_zone',
            4: 'grand_zone',
        };

        const organizerBooth = companyInfo.organizer_booth;
        const isDisplay = eventInfo.setting_booth[booth[organizerBooth]]?.settings_display_info_product.display_business_card;

        setEventDisplayBusinessCard(isDisplay);
    }, [eventInfo, companyInfo]);

    useEffect(() => {
        if (routeParams.shortName && routeParams.companyId) {
            getInformationEvent({
                event_name: shortName,
                company_id: companyId,
                language: locale,
            });
        }
    }, [shortName, companyId, locale]);
    
    /*  ★★ */
    useEffect(() =>{
    	getSettingCustomTimerctrl({eventShortName: shortName});
    	return () =>{
    		clearCustomTimerctrl();
    	}
    },[shortName] );
    

    const isProductsViewable = useMemo(() => {
        const currentDate = new Date();
        const startDate = new Date(eventInfo.sdate);
        const endDate = new Date(eventInfo.edate);

        const diffDays = Math.ceil((currentDate - endDate) / (1000 * 60 * 60 * 24));

        if(customTimerctrl && customTimerctrl.hasOwnProperty("TC_exhprod_after") ){
           return (   currentDate >= startDate && currentDate <= endDate)
                   || (currentDate > endDate && diffDays <= customTimerctrl.TC_exhprod_after);

        }else{
			//デフォルトで30日だから。
           return (currentDate >= startDate && currentDate <= endDate) || (currentDate > endDate && diffDays <= 30);
          }
    }, [eventInfo]);

    const handleFetchProductList = () => {
        if (productListOnDisplay.page < productListOnDisplay.total_page) {
            getProductListOnDisplay({
                event_name: shortName,
                company_id: companyId,
                page: productListOnDisplay.page + 1,
                page_size: parseInt(companyInfo.organizer_booth, 10) === BOOTH_TYPE.GRAND ? 24 : 5,
                language: locale,
            });
        }
    };
    const handleChange = (intersection) => {
        if (intersection) {
            handleFetchProductList();
        }
    };

    const options = {
        threshold: 1,
        rootMargin: '0px',
        onChange: handleChange,
    };

    return (
        <>
            {!_.isEmpty(eventInfo) && (
                <>
                    {parseInt(companyInfo.organizer_booth, 10) !== BOOTH_TYPE.GRAND
                        ? (
                            <SliderCustomer
                                data={productList}
                                fetchData={handleFetchProductList}
                                companyList={companyList}
                                nameEvent={shortName}
                                token={token}
                                companyId={companyId}
                                getProduct={getProduct}
                                product={product}
                                companyInfo={companyInfo}
                                totalProducts={productListOnDisplay.total_length}
                                eventDisplayBusinessCard={eventDisplayBusinessCard}
                                sendBusinessCard={sendBusinessCard}
                                successSendBusinessCard={successSendBusinessCard}
                                clearExchangeBusinessCard={clearExchangeBusinessCard}
                                isAuthorized={isAuthorized}
                                queryStr={queryStr}
                                isProductsViewable={isProductsViewable}
                                eventInfo={eventInfo}
                                customText={customText}
                                customColorExhibitor={customColorExhibitor}
                                customTextPersonInfo={customTextPersonInfo}
                                customTextCompany={customTextCompany}
                                isPreview={is_preview}
                            />
                        ) : (
                            <GrandBoothProductList
                                productList={productList}
                                fetchData={handleFetchProductList}
                                companyList={companyList}
                                nameEvent={shortName}
                                token={token}
                                companyId={companyId}
                                getProduct={getProduct}
                                product={product}
                                companyInfo={companyInfo}
                                totalProducts={productListOnDisplay.total_length}
                                isAuthorized={isAuthorized}
                                queryStr={queryStr}
                                isProductsViewable={isProductsViewable}
                                addProductToCart={addProductToCart}
                                clearAddToCart={clearAddToCart}
                                infoAddToCart={infoAddToCart}
                                isWeakAuth={isWeakAuth}
                                eventInfo={eventInfo}
                                getCount={getCount}
                                customText={customText}
                                customColorExhibitor={customColorExhibitor}
                                customTextPersonInfo={customTextPersonInfo}
                                customTextCompany={customTextCompany}
                                isPreview={is_preview}
                            />
                        )}
                </>
            )}
            <div style={{ marginTop: '100px', visibility: 'hidden' }}>Anchor. Do not touch to me!</div>
            <Observer {...options} />
            <Loader isLoading={isLoading} />
        </>
    );
};

ProductListOnDisplay.defaultProps = {
    productList: {},
    productListOnDisplay: {},
    favoriteCompanyIds: {},
    token: '',
    product: {},
    companyInfo: {},
    eventInfo: {},
    isAuthorized: false,
    companies: {},
    infoAddToCart: {},
    addProductToCart: () => {},
    clearAddToCart: () => {},
    getCount: () => {},
    customText: {},
    customColorExhibitor: {},
    customTextPersonInfo: {},
    getCustomText: () => {},
    clearCustomText: () => {},
    customTextCompany: {},
    locale: 'ja',
/* ★★ */
    getSettingCustomTimerctrl: () =>{},
    clearCustomTimerctrl : () => {},
    customTimerctrl: {},

};

ProductListOnDisplay.propTypes = {
    getProductListOnDisplay: PropTypes.func.isRequired,
    getInformationEvent: PropTypes.func.isRequired,
    clearGetInformationEvent: PropTypes.func.isRequired,
    productList: PropTypes.oneOfType([() => null, PropTypes.object]),
    productListOnDisplay: PropTypes.oneOfType([() => null, PropTypes.object]),
    favoriteCompanyIds: PropTypes.oneOfType([() => null, PropTypes.object]),
    product: PropTypes.oneOfType([() => null, PropTypes.object]),
    companyInfo: PropTypes.oneOfType([() => null, PropTypes.object]),
    isLoading: PropTypes.bool.isRequired,
    getFavoriteCompany: PropTypes.func.isRequired,
    getCommonCompanyInfo: PropTypes.func.isRequired,
    token: PropTypes.string,
    getProduct: PropTypes.func.isRequired,
    eventInfo: PropTypes.oneOfType([() => null, PropTypes.object]),
    isAuthorized: PropTypes.bool,
    companies: PropTypes.oneOfType([() => null, PropTypes.object]),
    getCompanyIdsByEvent: PropTypes.func.isRequired,
    sendBusinessCard: PropTypes.func.isRequired,
    clearExchangeBusinessCard: PropTypes.func.isRequired,
    successSendBusinessCard: PropTypes.bool.isRequired,
    companyIds: PropTypes.oneOfType([() => null, PropTypes.array]).isRequired,
    infoAddToCart: PropTypes.oneOfType([() => null, PropTypes.object]),
    addProductToCart: PropTypes.func,
    clearAddToCart: PropTypes.func,
    getCount: PropTypes.func,
    customText: PropTypes.oneOfType([() => null, PropTypes.object]),
    customColorExhibitor: PropTypes.oneOfType([() => null, PropTypes.object]),
    customTextPersonInfo: PropTypes.oneOfType([() => null, PropTypes.object]),
    getCustomText: PropTypes.func,
    clearCustomText: PropTypes.func,
    customTextCompany: PropTypes.oneOfType([() => null, PropTypes.object]),
    locale: PropTypes.string,
    
/*  ★★　*/ 
    getSettingCustomTimerctrl: PropTypes.func,
    clearCustomTimerctrl: PropTypes.func,
    customTimerctrl: PropTypes.oneOfType([() => null, PropTypes.object]),
};

export default ProductListOnDisplay;
